const colors = {
  black: '#000000',
  darkGreen: '#093434',
  successGreen: '#30BA34',
  electricBlue: '#7CE3E7',
  errorRed: '#C14B0B',
  gray: '#828282',
  inkBlue: '#04053a',
  mercury: '#E9E9E9',
  oathBlue: '#1410F9',
  platinum: '#E4E1DC',
  softGray: '#F2F2F2',
  lightGray: '#DADADA',
  white: '#FFFFFF',
};

export default colors;
